import { computed, Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, catchError, map, Observable, throwError } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CvatTasks } from '../models/tasks_cvat';
import { CvatProjects } from '../models/cvat-projects';

@Injectable({
  providedIn: 'root'
})
export class CvatProjectsService {
  private baseUrl: string = `${environment['api_backend']}/api`
  
  private ProjectSignal = signal <CvatProjects[]>([]);
  projects = computed(() => this.ProjectSignal());
  projects$ = new BehaviorSubject<CvatProjects[]>(this.ProjectSignal());
  
  private TasksSignal = signal <CvatTasks[]>([]);
  tasks = computed(() => this.TasksSignal());
  tasks$ = new BehaviorSubject<CvatTasks[]>(this.TasksSignal());

  private handleError(error: any): Observable <never> {
    console.error('An error occurred:', error);
    return throwError(error);
  }
  constructor(private http: HttpClient) {}
  
  loadProjects(): void {
      let params = new HttpParams().set('limit', '200');
      this.http.get<CvatProjects[]>(`${this.baseUrl}/cvat-projects`, {params}).subscribe({
        next: (response: any) => {
          const projects = response.results || []; 
          this.ProjectSignal.set(projects);
          this.projects$.next(projects);
          console.log('Datos del proyecto', projects)
        },
        error: (error) => this.handleError(error),
      });
    }

  loadProjectDetails(project_id: number): Observable<CvatProjects>{
   let params = new HttpParams().set('limit', '200');
    return this.http.get<CvatProjects>(`${this.baseUrl}/cvat-projects/${project_id}`, {params}).pipe(
      catchError(this.handleError)
    )
  }
  

  loadLabels(project_id: number, params: any): Observable <{count: number, results: any[]}>{
  //  let params = new HttpParams().set('limit', '200');
       return this.http.get<{count:number, results: any[] }>(`${this.baseUrl}/cvat-projects/${project_id}/labels`,  { params: new HttpParams({ fromObject: params }) }).pipe(
         catchError(this.handleError)
       );
  }
  
  addLabelsProjectCvat(project_id: number, labels: any[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/cvat-projects/${project_id}/add-labels`, labels ).pipe(
      map(response => {
        console.log('Labels added successfully', response);
        return response;
      }),
      catchError(error => {
        console.error('Error adding labels', error);
        return throwError(error);
      })
    );  

  }

  deleteLabels(label_id: number): Observable<any>{
      return this.http.delete(`${this.baseUrl}/cvat-projects/labels/${label_id}`).pipe(
        catchError(this.handleError)
      )
     
  }

  loadTasksByProject(project_id: number): void {
   let params = new HttpParams().set('limit', '200');
       this.http.get<CvatTasks[]>(`${this.baseUrl}/cvat-projects/${project_id}/tasks`, {params}).subscribe({
         next: (tasks: CvatTasks[]) => {
           this.TasksSignal.set(tasks);
           this.tasks$.next(tasks);
           console.log('Datos de la tarea', tasks);
         },
         error: (error) => this.handleError(error),
       });
  }

  deleteProject(project_id:number) {
      return this.http.delete(`${this.baseUrl}/cvat-projects/${project_id}`).pipe(
         catchError(this.handleError)
      );
  }
}
